<div class="h-full">
  <div class="w-full relative">
    @if (isLoading()) {
      <div class="w-full absolute">
        <mat-progress-bar
          class="mds-x-small"
          data-cy="recycle-bin-loader"
          [mode]="'indeterminate'"
        ></mat-progress-bar>
      </div>
    }
  </div>

  <div class="h-full flex flex-1 flex-col">
    <div class="flex flex-col p-4 bg-white border border-gray-0 rounded">
      <div class="flex mb-2">
        <div class="flex flex-1 font-semibold text-lg mr-4">{{ translations.title.text }}</div>
        <div class="flex items-center flex-row justify-end">
          <!-- reload -->
          <button
            modus-icon-button
            id="menu-bar-refresh"
            class="mx-1"
            [modus-tooltip]="translations.reload.tooltip.text"
            (click)="refreshClick()"
          >
            <md-icon>refresh</md-icon>
          </button>
        </div>
      </div>

      <div class="flex flex-col">
        @if (loadError()) {
          <modus-alert
            class="w-full mb-2"
            message="{{ translations.loadError.text }}"
            type="error"
          ></modus-alert>
        }
        <modus-alert class="w-full" message="{{ autoDeleteText() }}" type="info"></modus-alert>
      </div>
    </div>

    <div class="h-full min-w-full mt-4 overflow-hidden bg-white border border-gray-0 rounded">
      <mat-tab-nav-panel #tabPanel class="flex-auto">
        <mat-drawer-container class="h-full">
          <mat-drawer [opened]="showOptionsPanel()" mode="side" position="end" disableClose="true">
            <!-- options panel -->
            <sd-recycle-bin-options-panel
              class="flex h-full w-[330px]"
              [selectedScans]="selectedScans()"
              [previewVisible]="previewVisible()"
              [disabled]="disableActions()"
              (previewVisibleChanged)="previewVisibleChanged($event)"
              (closeClicked)="optionsCloseClicked()"
              (deleteClicked)="deleteScansPermanently()"
              (restoreClicked)="restoreScans()"
            ></sd-recycle-bin-options-panel>
          </mat-drawer>
          <mat-drawer-content class="bg-white">
            <!-- data table -->
            <sd-recycle-bin-table
              [chronologicalSelected]="chronologicalSelected()"
              [data]="recycledScansList()"
              [sortInfo]="sortInfo()"
              [disabled]="disableSelection()"
              (selectionChange)="selectionChange($event)"
              (sortInfoChange)="sortInfoChange($event)"
            ></sd-recycle-bin-table>

            @if (showEmpty()) {
              <sd-scandata-empty [reason]="emptyReason"></sd-scandata-empty>
            }
          </mat-drawer-content>
        </mat-drawer-container>
      </mat-tab-nav-panel>
    </div>
  </div>
</div>
